var axios = require('axios').default;
var httpStatus = require('../utils/httpStatus.js')
var httpStatus = require("@/helper/hc-request/lib/utils/httpStatus");

const TIME_OUT = 12000

class HCRequest {

  constructor(url = null, body = null, headers = null, base = null, authorization = null, auth = null, params = null) {
    this.url = url,
      this.body = body,
      this.headers = headers
    this.base = base
    this.authorization = authorization,
      this.auth = auth,
      this.params = params,
      this.instance = axios.create()
    this.interceptors = null
  }

  async get() {

    try {
      if (!!this.authorization) {
        if (this.headers == null) {
          this.headers = { Authorization: this.authorization }
        } else {
          Object.assign(this.headers, { Authorization: this.authorization });
        }
      }

      if (!this.url) { throw new Error("hc-request: url no valido") }
      if (!this.base) { throw new Error("hc-request: base no valido") }


      this.instance.defaults.baseURL = this.base
      this.instance.defaults.headers = this.headers
      this.instance.defaults.params = this.params
      this.instance.defaults.data = this.body
      this.instance.defaults.timeout = TIME_OUT
      this.instance.defaults.auth = this.auth

      let result;

      await this.instance
        .get(this.url, { validateStatus: function (status) { return status == httpStatus.SUCCESS } })
        .then((response) => {
          if (response) {
            return response = { "success": true, "status": response.status, "statusText": response.statusText, "data": response.data };
          } else {
            return response = { "success": false, "status": 0, "statusText": "Sin datos", "data": null, "headers": response.headers };
          }
        })
        .then((contests) => {
          result = contests;
        })
        .catch((error) => {
          if (error.response) {
            result = { "success": false, "status": error.response.status, "statusText": error.response.statusText, "data": error.response.data }
          } else {
            result = { "success": false, "status": 0, "statusText": "Error al realizar la petición", "data": null, "headers": null }
          }
        });
      return result;
    } catch (error) {
      throw new Error(error.message)
    }
  }
  async post() {

    if (!!this.authorization) {
      if (this.headers == null) {
        this.headers = { Authorization: this.authorization }
      } else {
        Object.assign(this.headers, { Authorization: this.authorization });
      }
    }

    this.instance.defaults.baseURL = this.base
    this.instance.defaults.headers = this.headers
    this.instance.defaults.params = this.params
    this.instance.defaults.timeout = TIME_OUT
    this.instance.defaults.auth = this.auth

    let result;
    await this.instance
      .post(this.url, this.body, { validateStatus: function (status) { return status == httpStatus.SUCCESS } })
      .then((response) => {
        if (response) {
          return response = { "success": true, "status": response.status, "statusText": response.statusText, "data": response.data };
        } else {
          return response = { "success": false, "status": 0, "statusText": "Sin datos", "data": null };
        }
      })
      .then((contests) => {
        result = contests;
      })
      .catch((error) => {
        if (error.response) {
          result = { "success": false, "status": error.response.status, "statusText": error.response.statusText, "data": error.response.data}
        } else {
          result = { "success": false, "status": 0, "statusText": "Error al realizar la petición", "data": null }
        }
      });
    return result;
  }
  async put() {

    if (!!this.authorization) {
      if (this.headers == null) {
        this.headers = { Authorization: this.authorization }
      } else {
        Object.assign(this.headers, { Authorization: this.authorization });
      }
    }


    this.instance.defaults.baseURL = this.base
    this.instance.defaults.headers = this.headers
    this.instance.defaults.params = this.params
    this.instance.defaults.data = this.body
    this.instance.defaults.timeout = TIME_OUT
    this.instance.defaults.auth = this.auth

    let result;
    await this.instance
      .put(this.url, this.body, { validateStatus: function (status) { return status == httpStatus.SUCCESS } })
      .then((response) => {
        if (response) {
          return response = { "success": true, "status": response.status, "statusText": response.statusText, "data": response.data };
        } else {
          return response = { "success": false, "status": 0, "statusText": "Sin datos", "data": null };
        }
      })
      .then((contests) => {
        result = contests;
      })
      .catch((error) => {
        if (error.response) {
          result = { "success": false, "status": error.response.status, "statusText": error.response.statusText, "data": error.response.data }
        } else {
          result = { "success": false, "status": 0, "statusText": "Error al realizar la petición", "data": null }
        }
      });
    return result;
  }
  async delete() {

    if (!!this.authorization) {
      if (this.headers == null) {
        this.headers = { Authorization: this.authorization }
      } else {
        Object.assign(this.headers, { Authorization: this.authorization });
      }
    }



    this.instance.defaults.baseURL = this.base
    this.instance.defaults.headers = this.headers
    this.instance.defaults.params = this.params
    this.instance.defaults.data = this.body
    this.instance.defaults.timeout = TIME_OUT
    this.instance.defaults.auth = this.auth

    let result;
    await this.instance
      .delete(this.url, { validateStatus: function (status) { return status == httpStatus.SUCCESS } })
      .then((response) => {
        if (response) {
          return response = { "success": true, "status": response.status, "statusText": response.statusText, "data": response.data };
        } else {
          return response = { "success": false, "status": 0, "statusText": "Sin datos", "data": null };
        }
      })
      .then((contests) => {
        result = contests;
      })
      .catch((error) => {
        if (error.response) {
          result = { "success": false, "status": error.response.status, "statusText": error.response.statusText, "data": error.response.data }
        } else {
          result = { "success": false, "status": 0, "statusText": "Error al realizar la petición", "data": null }
        }
      });
    return result;
  }
}

module.exports = HCRequest;